import React, { useEffect, useState, useRef } from "react";
// import * as XLSX from "xlsx";
import './AdminPage.css';
import { useMsal } from "@azure/msal-react";
// import KeyData from "../KeyData.json";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import Alert from '@mui/material/Alert';
// import SampleExcel from '../../data/KeyStatistics-Sample.xlsx';
import axios from "axios";
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { styled } from "@mui/material/styles";
// import Alert from 'react-bootstrap/Alert';
import mailData from "../../Data/mailData.js";

const ColorButton = styled(Button)(({ theme }) => ({
    color: theme.palette.getContrastText("#7500C0"),
    backgroundColor: "#7500C0",
    "&:hover": {
        backgroundColor: "#7500C0",
        color: "#fff",
    },
}));

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 700,
    bgcolor: 'background.paper',
    border: '0.1px solid #000',
    boxShadow: 24,
    p: 4,
    borderRadius: '5px',
    padding: 0
};

const DeleteUser = () => {

    //   const [tech, setTech] = React.useState('');
    //   const [isTechNull, setIsTechNull] = useState(false);
    const [isAddUserOpen, setIsAddUserOpen] = useState(false);
    const [oldUser, setOldUser] = useState("");
    const [isUserNameNull, setIsUserNameNull] = useState(false);
    // const [newAlert, setNewAlert] = useState(false);

    const saveDeleteHandle = () => {
        // if (newUser == "" && tech == "") {
        //   setIsUserNameNull(true);
        //   setIsTechNull(true);
        //   setIsAddUserOpen(true);
        //   setNewUser("");
        //   setTech("");
        // }
        if (oldUser == "") {
            setIsUserNameNull(true);
            setIsAddUserOpen(true);
        } else {
            // axios.post("http://localhost:3021/track/deleteUser", { oldUser })
            axios.post("https://atci.lkm.qa.accenture.com/qa-apis/track/deleteUser", { oldUser })
                .then((res) => {
                    console.log(res, "res from post addUser")
                    // setAlert(true);
                    setAlert(1);
                    console.log(res.status, "status code")
                    if (res.status == 204) {
                        // setNewAlert(true);
                        setAlert(3);
                    }
                })
                .catch((err) => {
                    console.log(err, "error msg")
                    // setAlert(false);
                    setAlert(2)
                })
            setOldUser("");
            // setTech("");
            handleClose();
        }

    }

    // const handleTechChange = (event) => {
    //     setTech(event.target.value);
    //     setIsTechNull(false);
    // };

    const [open, setOpen] = useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => {
        setOpen(false);
    }

    // on change states
    const [excelFile, setExcelFile] = useState(null);
    const [excelFileError, setExcelFileError] = useState(null);
    const [boolData, setBoolData] = useState(false);
    const [inputChange, setInputChange] = useState("");
    const [alert, setAlert] = useState(0);

    const [excelData, setExcelData] = useState(null);

    const [show, setShow] = useState(false);
    const [showUser, setShowUser] = useState(false);
    const { instance } = useMsal();

    const usersList = [
        "uma.rani.battu",        
        "jeevadharani.ramanan",
        "reshmi.haridas.m",
        "ankur.e.mishra",        
        "aluru.akash",
        "arpita.m.singh",
        "h.srinivasan",
        "j.b.bhardwaj",
        "aayushi.bharti",                
        "shramika.s.ambolkar",        
        "sridhar.aluri",
        "varsha.a.tyagi"
    ];

    const activeAccount = instance.getActiveAccount();

    useEffect(() => {
        if (activeAccount) {
            let enterpriseId = activeAccount.username.split('@')[0];
            const val = usersList.some((item) => item === enterpriseId)
                ? setShowUser(true)
                : "Byee";

            console.log(val);
        } else {
            console.log("Something Wrong.....!");
        }
    }, [activeAccount]);

    const handleAlertClose = () => {
        // setAlert(undefined);
        setAlert(0);
        // setNewAlert(false);
    };

    alert == 1 && setTimeout(handleAlertClose, 5000);
    alert == 2 && setTimeout(handleAlertClose, 5000);
    alert == 3 && setTimeout(handleAlertClose, 5000);



    return (
        <>
            {console.log(excelData, "excel dataaaaaaaaaa")}
            <div className="alert-container">
                {alert == 1 && <Alert onClose={handleAlertClose} className="alert-line">Deleted Successfully!!</Alert>}
                {alert == 2 && <Alert severity="error" onClose={handleAlertClose} className="alert-line">Deletion Failed!</Alert>}
                {alert == 3 && <Alert severity="error" onClose={handleAlertClose} className="alert-line">No such user found for deletion!</Alert>}

                {console.log(alert, "alert in starting")}

            </div>
            {showUser && (
                <div className="admin_container1">
                    {/* MUI Modal  */}
                    <Button onClick={handleOpen} className="admin-button">Delete User</Button>
                    <Modal
                        open={open}
                        onClose={handleClose}
                        aria-labelledby="modal-modal-title"
                        aria-describedby="modal-modal-description"
                    >
                        <Box sx={style} className="modal-box-container">
                            <div className="modal-box-wrap">
                                <h2>Delete User</h2>
                                {/* <hr></hr> */}
                                <img src="/images/AdminPage/CloseIcon.png" onClick={handleClose} alt="close-icon" className="close-button"></img>

                                {/* <form onSubmit={handleSubmit} className="modal-box-form" id='form'> */}
                                <div className="enterprise-box">
                                    <label>Enter Enterprise ID: </label>
                                    <TextField className="textfield" id="outlined-basic" multiline variant="outlined"
                                        placeholder={`Eg: ${mailData.adminPlaceholder}`}
                                        error={isUserNameNull && isAddUserOpen ? true : false}
                                        required={isUserNameNull && isAddUserOpen ? false : true}
                                        onChange={(e) => {
                                            setOldUser(e.target.value);
                                            setIsUserNameNull(false);
                                            if (oldUser !== "") {
                                                setIsUserNameNull(false);
                                            }
                                        }}
                                        helperText={
                                            isUserNameNull && isAddUserOpen
                                                ? "Please enter the user name"
                                                : null
                                        }
                                    />
                                </div>
                                {console.log(oldUser, "oldUser value onChange")}

                                {/* {console.log(tech, "tech value")} */}
                                <DialogActions
                                    sx={{
                                        justifyContent: "center",
                                        alignItems: "center",
                                        marginBottom: "10px",
                                    }}
                                >
                                    <ColorButton
                                        variant="contained"
                                        className="save-button"
                                        size="small"
                                        sx={{ background: "#7500C0", color: "white" }}
                                        autoFocus
                                        onClick={saveDeleteHandle}
                                    >
                                        Submit
                                    </ColorButton>
                                    <ColorButton
                                        variant="contained"
                                        className="cancel-button"
                                        size="small"
                                        sx={{
                                            background: "white",
                                            color: "#7500C0",
                                            border: "solid 1px #7500C0",
                                        }}
                                        autoFocus
                                        onClick={handleClose}
                                    >
                                        Cancel
                                    </ColorButton>

                                </DialogActions>
                                {console.log(alert, "alert after submit")}
                                {/* <div className="submit-btn-container">
                    <Button
                      type="submit"
                      className="submit-btn"
                      disabled={inputChange === "" ? true : false}
                      onClick={() => setTimeout(() => {
                        setAlert(true)
                        handleClose();
                      }, 500)}
                    >
                      Publish Data
                    </Button>
                  </div> */}
                                {/* </form> */}


                            </div>
                        </Box>
                    </Modal>

                </div>
            )}
        </>
    );
};

export default DeleteUser;
